module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content close-date-picker city_collection_reports_pop",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "general_reports_btn",
    class: [_vm.addButtonClass, {
      general_reports_btn1: _vm.tableCount <= 10
    }]
  }, [_c('button', {
    staticClass: "btn gradientbt",
    on: {
      "click": _vm.refreshReportList
    }
  }, [_vm._v("Refresh")]), _vm._v(" "), _c('button', {
    staticClass: "btn gradientbt ml-5 generate_report",
    on: {
      "click": _vm.gotoReportGeneration
    }
  }, [_vm._v("\n        Generate Reports\n      ")])]), _vm._v(" "), _c('v-server-table', {
    ref: "dailyCityCollectionReportTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "c-pointer"
        }, [(props.row.fileUrl == '') ? _c('a', {
          attrs: {
            "disabled": ""
          }
        }, [_vm._v("Your report is generating. Please wait...")]) : _vm._e(), _vm._v(" "), (props.row.fileUrl != '') ? _c('a', {
          staticClass: "fa fa-download",
          attrs: {
            "role": "button",
            "href": props.row.fileUrl,
            "target": "_blank"
          }
        }) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1), _vm._v(" "), (_vm.isGenerateReport) ? _c('div', {}, [_c('div', {}, [_c('div', {}, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('vue-form', {
    attrs: {
      "state": _vm.formstate
    }
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Generate Reports")]), _vm._v(" "), (_vm.reportLoading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader'), _vm._v(" "), _c('p', [_vm._v("Please wait, report generation is in progress.")])], 1) : _vm._e(), _vm._v(" "), (!_vm.reportLoading) ? _c('div', {
    staticClass: "col-sm-12 scroll_pop",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [(_vm.adminCheck == 'superAdmin') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cityId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dailyCityCollectionReport.cityId),
      expression: "dailyCityCollectionReport.cityId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "cityId",
      "disabled": _vm.isCityDisable
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dailyCityCollectionReport, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onCheckedCity($event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select City Name")]), _vm._v(" "), _vm._l((_vm.citys), function(cityId) {
    return _c('option', {
      domProps: {
        "value": cityId.id
      }
    }, [_vm._v("\n                          " + _vm._s(cityId.name) + "\n                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cityId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is a required field")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.startDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Trip Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "startDate",
      "required": "",
      "lang": "en",
      "name": "startDate",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY",
      "not-after": _vm.disabledAfter
    },
    on: {
      "change": _vm.datevalidation
    },
    model: {
      value: (_vm.dailyCityCollectionReport.startDate),
      callback: function($$v) {
        _vm.$set(_vm.dailyCityCollectionReport, "startDate", $$v)
      },
      expression: "dailyCityCollectionReport.startDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "startDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onModalClose
    }
  }, [_vm._v("\n                  Cancel\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.generateReport
    }
  }, [_vm._v("\n                  Generate\n                ")])])], 1)])])])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-41e42ba1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41e42ba1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/wasteReports/daily_city_collection_reports.vue
// module id = 2309
// module chunks = 0